import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { IPartnerApplication } from '../../interfaces/IPartnerApplication';
import { IPartner } from '../../interfaces/IPartner';
import { IPartnerToken } from '../../interfaces/IPartnerToken';
import { IRestaurant } from '../../interfaces/IRestaurant';

const apiUrl = Globals.apiPath + '/partners';

export default class PartnersService {
  constructor() {}

  async getLastApplication() {
    let res = await axios.get<IPartnerApplication>(`${apiUrl}/last`);
    return res.data;
  }

  async getByUser(userId: number) {
    let res = await axios.get<IPartner>(`${apiUrl}?uId=${userId}`);
    return res.data;
  }

  async getStores(userId: number) {
    let res = await axios.get<IRestaurant[]>(`${apiUrl}/${userId}/stores`);
    return res.data;
  }

  async apply() {
    let res = await axios.post<IPartnerApplication>(`${apiUrl}/apply`);
    return res.data;
  }

  async saveSettings(
    userId: number,
    settings: { paypalAccount: string; mpaAccount: string }
  ) {
    let res = await axios.put<IPartner>(`${apiUrl}/${userId}`, settings);
    return res.data;
  }

  async createToken(id: string) {
    let res = await axios.post<IPartnerToken>(`${apiUrl}/tokens`, { id });
    return res.data;
  }
}
